import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  thumb: {
    color: 'inherit',
    border: `.0631rem solid ${t.thumbBorderColor}`,
    padding: '.2rem',
    backgroundColor: t.thumbBgColor,
    outline: 0,
    transition: 'none',
    cursor: 'pointer',
    margin: '.4rem 0',

    '&:focus, &:active:focus': {
      outline: '0',
      boxShadow: `0 0 0 .2rem ${t.thumbBorderFocusColor}`,
    },

    '&:hover': {
      borderColor: t.thumbBorderColorHover,
    },
  },

  image: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    width: '5rem',
    height: '5rem',

    '& img': {
      objectFit: 'contain',
      width: '100%',
      height: '100%',
    },
  },

  imagesContainer: {
    display: '-webkit-inline-box',
  },

  originalImageContainer: {
    maxWidth: '50%',
  },

  originalImage: {
    maxWidth: '100%',
  },

  heatmapImageContainer: {
    maxWidth: '50%',
  },

  heatmapImage: {
    maxWidth: '100%',
  },
}))

export default useStyles
